import { useTranslation } from 'react-i18next';
import { ReactComponent as PhoneIcon } from 'icons/phone.svg';
import { Tooltip } from 'components/Tooltip';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { Option, PhoneIconButton } from '../CarrierInformation.styles';

interface CarrierPhoneIconProps {
  phone: string;
}

const TOOLTIP_ID = 'carrier-phone-icon-tooltip';

export const CarrierPhoneIcon = ({
  phone,
}: CarrierPhoneIconProps): JSX.Element => {
  const { t } = useTranslation();
  const { isDesktop } = useDetectDevice();

  if (isDesktop) {
    return (
      <>
        <PhoneIconButton
          id="carrier-phone"
          data-tooltip-id={TOOLTIP_ID}
          aria-label={t('PTP_ALT_TEXT_PHONE')}
        >
          <PhoneIcon />
        </PhoneIconButton>
        <Tooltip id={TOOLTIP_ID} render={() => <span>{phone}</span>} />
      </>
    );
  }

  return (
    <Option
      url={`tel: ${phone}`}
      type="phone"
      id="carrier-phone"
      ariaLabel={`${t('PTP_ALT_TEXT_PHONE')} ${phone}`}
    >
      <PhoneIcon />
    </Option>
  );
};
